import React from 'react';
import {Table, Modal, Button} from 'semantic-ui-react';
import Currency from "../../components/formatters/currency";
import FormattedDate from "../../components/formatters/formattedDate";
import ContractDetailsContainer from "./contract-details-container";

export default class ContractsMainTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell><FormattedDate value={this.props.data.constractStartDate} /></Table.Cell>
                <Table.Cell><FormattedDate value={this.props.data.constractEndDate} /></Table.Cell>
                <Table.Cell>{this.props.data.supplierName}</Table.Cell>
                <Table.Cell>{this.props.data.utilityAlias}</Table.Cell>
                <Table.Cell><Currency value={this.props.data.tradedCost} /></Table.Cell>
                <Table.Cell><Currency value={this.props.data.exposedCost} /></Table.Cell>
                <Table.Cell><Currency value={this.props.data.markCostPerUnit} /></Table.Cell>
                <Table.Cell>
                    <Modal size="fullscreen" trigger={<Button basic>Contract Details</Button>} centered={true} closeIcon>
                        <Modal.Header><h2>Contract Details</h2></Modal.Header>
                        <Modal.Content>
                            <ContractDetailsContainer customerId={this.props.contextData.customerId} contract={this.props.data} />
                        </Modal.Content>
                    </Modal>
                </Table.Cell>
            </Table.Row>
        );
    }
}